import type { AnchorHeight } from './IProjection';

/**
 * Ankerhoehen der welt-gebundenen DOM-Elemente. Die Werte der Draufsicht sind
 * die bisherigen Bildschirm-Versaetze; die Welt-Hoehen daneben gelten fuer die
 * Ego-Ansicht, wo eine Figur rund 1,5 Tiles misst (ein Tile entspricht etwa
 * einem Meter).
 */

/**
 * Video-Bubble ueber dem Namensschild. Die Werte sind so gestaffelt, dass
 * Figur, Namensschild, Bubble und geteilter Bildschirm einander nicht
 * verdecken (Figur rund 48, Namensschild rund 58 Einheiten hoch).
 */
export const ANCHOR_BUBBLE: AnchorHeight = { screenOffsetY: -148, worldHeight: 80 };

/** Geteilter Bildschirm haengt ueber der Bubble. */
export const ANCHOR_SCREENSHARE: AnchorHeight = { screenOffsetY: -216, worldHeight: 125 };

/**
 * "E druecken" direkt am Objekt.
 *
 * Die Welt-Hoehe liegt knapp unter der Augenhoehe (1,7 m) und damit hoeher,
 * als das Schild eigentlich sitzen muesste. Der Grund ist der Nahbereich:
 * ein Anker deutlich unter der Augenhoehe rutscht beim Herantreten unten aus
 * dem Bild, und die Projektion blendet ihn dann aus — der Hinweis
 * verschwand also genau dann, wenn man direkt vor dem Whiteboard stand. Auf
 * Augenhoehe bleibt er bis auf Armlaenge sichtbar, auch beim engsten
 * Sichtfeld.
 */
export const ANCHOR_HINT: AnchorHeight = { screenOffsetY: -36, worldHeight: 52 };
